import {computed} from 'vue'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import {useAuthenticationStore} from '@/stores'
import {storeToRefs} from 'pinia'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'

let utc = require('dayjs/plugin/utc')
let timezone = require('dayjs/plugin/timezone')
let duration = require('dayjs/plugin/duration')
dayjs.extend(duration)
dayjs.extend(relativeTime)
dayjs.extend(timezone)
dayjs.extend(utc)
dayjs.extend(isSameOrBefore)

let _userRef

function getUserRef() {
  if (_userRef) {
    return _userRef
  }

  const auth = useAuthenticationStore()
  const {user} = storeToRefs(auth)
  _userRef = user

  return _userRef
}

export const timeFormat = 'HH:mm'

export let authUserDateFormat = computed(() => {
  const mapper = {
    'm/d/Y': 'MM/DD/YYYY',
    'd.m.Y': 'DD.MM.YYYY',
  }
  return mapper[getUserRef().value.date_format] || 'YYYY-MM-DD'
})

export let authUserDateFormatLowercase = computed(() => {
  const mapper = {
    'm/d/Y': 'mm/dd/yyyy',
    'd.m.Y': 'dd.mm.yyyy',
  }
  return mapper[getUserRef().value.date_format] || 'yyyy-mm-dd'
})

export function formatDate(created_at) {
  return dayjs(created_at).format(`${authUserDateFormat.value}`)
}

export function formatDateShort(date) {
  return dayjs(date).format('MMM D')
}

export function formatTime(created_at) {
  return dayjs(created_at).format(timeFormat)
}

export function formatTimeFromNow(created_at) {
  let actualTime = dayjs().tz(getUserRef().value.timezone).format('YYYY-MM-DD HH:mm:ss')

  return dayjs(created_at).from(actualTime)
}

export function formatDateWithTime(created_at) {
  return dayjs(created_at).format(`${authUserDateFormat.value} ${timeFormat}`)
}

export function formatDateMonthWithTime(created_at) {
  return dayjs(created_at).format(`DD MMM ${timeFormat}`)
}

export function formatSeconds(seconds) {
  return dayjs
    .duration(seconds, 'seconds')
    .format(seconds >= 86400 ? 'D[d] H[h]' : seconds >= 3600 ? 'H[h] m[m]' : 'm[m]')
}

export function isWithinDateRange(startDate, endDate) {
  const currentDate = dayjs()
  const start = dayjs(startDate)
  const end = dayjs(endDate).endOf('day')

  return currentDate.isAfter(start) && currentDate.isSameOrBefore(end)
}
